<script>
    import Feedback from "./Feedback.svelte";
    export let user_language;
</script>

<footer>
    <Feedback {user_language} />
</footer>

<style>
    footer {
        background-color: var(--background-color-light);
        text-align: center;
        padding: 0.5em;
    }
</style>
